import request from "@/utils/request";
// 人工开考某一考试活动
export function openExamActivity(data) {
  return request({
    url: "local_exam_open_exam_activity",
    method: "GET",
    params: data,
  });
}
// 查看考试活动详情
export function getExamActivityDetail(data) {
  return request({
    url: "local_exam_read_exam_activity",
    method: "GET",
    params: data,
  });
}
// 获取某一考试详情
export function getExamDetail(data) {
  return request({
    url: "local_exam_read_exam",
    method: "GET",
    params: data,
  });
}
// 获取根据班级或学员获取已注册考试列表
export function getExamByStudentOrClass(data) {
  return request({
    url: "local_exam_exam_list_by_user",
    method: "GET",
    params: data,
  });
}
// // 根据考试获取已注册学员或班级
export function getExamRegister(data) {
  return request({
    url: "local_exam_search_register_exam",
    method: "GET",
    params: data,
  });
}
// 获取已注册学员
export function getRegisterStudent(data) {
  return request({
    url: "local_exam_exam_student_list",
    method: "GET",
    params: data,
  });
}
// 获取已添加学员
export function getAddStudent(data) {
  return request({
    url: "local_exam_exam_activity_student_list",
    method: "GET",
    params: data,
  });
}
// 添加考试活动
export function createExamActivity(data) {
  return request({
    url: "local_exam_create_exam_activity",
    method: "GET",
    params: data,
  });
}
// 编辑考试活动
export function editExamActivity(data) {
  return request({
    url: "local_exam_edit_exam_activity",
    method: "GET",
    params: data,
  });
}
// 编辑考试活动
export function deleteExamActivity(data) {
  return request({
    url: "local_exam_delete_exam_activity",
    method: "GET",
    params: data,
  });
}
// 添加考试安排学员
export function addExamArrangeStudent(data) {
  return request({
    url: "local_exam_exam_activity_add_student",
    method: "GET",
    params: data,
  });
}
// 考试注册-获取班级注册列表接口
export function getExamClassRegisterList(data) {
  return request({
    url: "local_exam_class_register_list",
    method: "GET",
    params: data,
  });
}

// 考试注册-获取学员注册列表接口
export function getExamStudentRegisterList(data) {
  return request({
    url: "local_exam_student_register_list",
    method: "GET",
    params: data,
  });
}

// 考试注册-获取考试列表接口
export function getExamList(data) {
  return request({
    url: "local_exam_exam_list",
    method: "GET",
    params: data,
  });
}
// 考试注册-获取学员列表接口
export function getExamStudentList(data) {
  return request({
    url: "local_exam_student_list",
    method: "GET",
    params: data,
  });
}
// 考试注册-获取班级列表
export function getExamClassList(data) {
  return request({
    url: "local_exam_class_list",
    method: "GET",
    params: data,
  });
}
// 考试注册-注册学员
export function registerExam(data) {
  let users = {};
  // if (data.data) {
  //   data.data.forEach((item, index) => {
  //     users[`data[${index}][id]`] = item.id;
  //     users[`data[${index}][type]`] = "user";
  //   });
  //   delete data.data;
  // }
  return request({
    url: "local_exam_register_exam",
    method: "GET",
    params: {
      ...data,
      ...users,
    },
  });
}

// 考试注册-考试取消注册接口
export function unregisterExam(data) {
  return request({
    url: "local_exam_unregister_exam",
    method: "GET",
    params: data,
  });
}

// 考试活动-应考名单
export function getExamActivityStudent(data) {
  return request({
    url: "local_exam_exam_activity_student",
    method: "GET",
    params: data,
  });
}

// 学员端-我的考试列表
export function getMyActivityList(data) {
  return request({
    url: "local_exam_student_student_activity_list",
    method: "GET",
    params: data,
  });
}

// 学员端-答题
export function replyQuestion(data) {
  return request({
    url: "local_exam_student_reply_question",
    method: "GET",
    params: data,
  });
}

// 学员端-纪录切屏次数
export function leaveRecord(data) {
  return request({
    url: "local_exam_student_action_record",
    method: "GET",
    params: data,
  });
}

// 学员端-交卷
export function submitActivity(data) {
  return request({
    url: "local_exam_student_submit_activity",
    method: "GET",
    params: data,
  });
}
// 考试类型
export function examActivity(data) {
  return request({
    url: "local_exam_exam_category",
    method: "GET",
    params: data,
  });
}
// 教师考试阅卷
export function teacherMarkingList(data) {
  return request({
    // url: "local_exam_grade_teacher_activity_list",
    url: "local_exam_new_search_grade_list",
    method: "GET",
    params: data,
  });
}
// 参与考试学生列表
export function markingStuList(data) {
  return request({
    url: "local_exam_reply_activity_list",
    method: "GET",
    params: data,
  });
}
// 获取考试单位的列表
export function departmentList(data) {
  return request({
    url: "tool_deptmanage_get_departments",
    method: "GET",
    params: data,
  });
}
// 获取阅卷详情接口
export function markDetail(data) {
  return request({
    url: "local_exam_grade_get_paper",
    method: "GET",
    params: data,
  });
}
// 阅卷评分接口
export function markGrade(data) {
  return request({
    url: "local_exam_graded",
    method: "GET",
    params: data,
  });
}
// 复制考试
export function copyExam(data) {
  return request({
    url: "local_exam_copy_exam",
    method: "GET",
    params: data,
  });
}
//考试成绩列表
export function examGradeList(data) {
  return request({
    url: "local_exam_new_search_grade_list",
    method: "GET",
    params: data,
  });
}
// 考生成绩列表
export function examStuGradeList(data) {
  return request({
    url: "local_exam_exam_student_grade_list",
    method: "GET",
    params: data,
  });
}
// 考生答题试卷
export function stuExamPaperDetail(data) {
  return request({
    url: "local_exam_student_paper",
    method: "GET",
    params: data,
  });
}
// 某考试的学生列表
export function stuExamStuGradeList(data) {
  return request({
    // url: "local_exam_activity_student_grade_list",
    url: "local_exam_search_exam_grade_list",
    method: "GET",
    params: data,
  });
}
// 某考试的考试列表
export function stuExamGradeList(data) {
  return request({
    url: "local_exam_search_exam_grade_list",
    method: "GET",
    params: data,
  });
}
// 考试分析数据
export function examAnalysis(data) {
  return request({
    url: "local_exam_analysis_exam",
    method: "GET",
    params: data,
  });
}
//考试分析学生列表
export function examAnalysisList(data) {
  return request({
    url: "local_exam_analysis_exam_student_list",
    method: "GET",
    params: data,
  });
}
// 获取开卷老师和阅卷老师
export function examTeachers(data) {
  return request({
    url: "local_exam_teacher_list ",
    method: "GET",
    params: data,
  });
}
// 获取课程章节
export function examSection(data) {
  return request({
    url: "local_exam_section_list",
    method: "GET",
    params: data,
  });
}
// 获取考试成绩单
export function stuGradePage(data) {
  return request({
    url: "local_exam_transcript",
    method: "GET",
    params: data,
  });
}
// 修改学生考试成绩
export function changeStuGrade(data) {
  return request({
    url: "local_exam_change_student_grade",
    method: "GET",
    params: data,
  });
}
// 考试课程列表
export function examCourseList(data) {
  return request({
    url: "local_exam_course_list",
    method: "GET",
    params: data,
  });
}
// 考试课程列表
export function examCourseCategoryList(data) {
  return request({
    url: "local_exam_course_category_list",
    method: "GET",
    params: data,
  });
}
// 考试回收站列表
export function examRecycleList(data) {
  return request({
    url: "local_exam_recycle_list",
    method: "GET",
    params: data,
  });
}
// 回收站完全删除考试接口
export function examRecycleDelList(data) {
  return request({
    url: "local_exam_completely_delete_exam",
    method: "GET",
    params: data,
  });
}
// 回收站恢复删除考试接口
export function recycleRestore(data) {
  return request({
    url: "local_exam_restore_exam",
    method: "GET",
    params: data,
  });
}
